import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import DaccaButton from '../../../custom/dacca-button';
import { Dispatch } from 'redux';
import { ReportTypeTC } from '../../../../business/models/typecode.enums';
import { SvsItem, TabDetails } from '../../../../store/details/svs/types';
import { SvsViews } from '../../../../store/details/svs/model';
import { connect } from 'react-redux';
import { fetchSvs, fetchSvsList } from '../../../../store/details/svs/actions';
import styles from './svs-list.module.css';
import { Role } from '../../../../store/shared/model';
import BelfiusCurrencyText from '../../../custom/belfius-currency-text';

interface PropsFromDispatch {
    readonly fetchSvs: typeof fetchSvs;
    readonly fetchSvssTotal: typeof fetchSvsList;
}

interface PropsFromState {
    readonly data: SvsItem[];
    readonly currentSvsId: number;
    readonly itemsTabs: { [key: string]: TabDetails };
    readonly svsBlocked: boolean;
    readonly instructionId: number;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class SvsList extends React.Component<AllProps> {
    render() {
        const isSelectedItem = (item: SvsItem) => item.id === this.props.currentSvsId;
        const isLockedItem = (item: SvsItem) => item.locked || this.props.svsBlocked;

        const getBorderClass = (item: SvsItem) => {
            if (isSelectedItem(item)) {
                 return styles.borderActive;
            }
            if (isLockedItem(item)) {
                return styles.borderLocked;
            }
            return styles.border;
        };

        const getBackgroundClass = (item: SvsItem) => {
            if (isLockedItem(item)) {
                return styles.backgroundLocked;
            }
            return styles.background;
        };

        const getTabIndicatorRowBodyClass = (item: SvsItem, view: SvsViews) => {
            if (!this.props.itemsTabs[`${item.id}`]) { return styles.tabIndicatorRowBodyGreen; }
            const isTabSaved = this.props.itemsTabs[`${item.id}`][view].isSaved;

            if (!isTabSaved) { return styles.tabIndicatorRowBodyRed; }

            return styles.tabIndicatorRowBodyGreen;
        };

        const itemList = this.props.data.map(item => {
            return (
                <div key={item.id} className={`${styles.item} ${getBorderClass(item)} ${getBackgroundClass(item)}`} onClick={() => {
                    this.props.fetchSvs(item.id);
                }}>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>{item.id}</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.valueAndCause)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.svsLines)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.vatAndPayment)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.counterExpertise)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.remark)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.communication)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorRow}>
                        <div className={styles.tabIndicatorRowSpacer}>&nbsp;</div>
                        <div className={getTabIndicatorRowBodyClass(item, SvsViews.signing)}>&nbsp;</div>
                    </div>
                    <div className={styles.tabIndicatorTotalRow}>
                    <BelfiusCurrencyText
                        value={item.total ? item.total : 0}
                        prefix=' €' />
                    </div>
                </div>
            );
        }
        );

        return (
          <div className={styles.container}>
            <div className={styles.itemRow}>
              {itemList}
            </div>
            <div className={styles.buttonContainer}>
              <DaccaButton
                {...this.props}
                reportType={ReportTypeTC.Svs}
              />
              <div className={styles.addbutton} onClick={() => {
                  if (this.props.svsBlocked) { return; }
                  this.props.fetchSvs(0); }
                }>
                <img alt="" src={require('../../../../assets/images/add_85x85.png')} />
              </div>
            </div>
          </div>
        );
    }
}

const mapStateToProps = ({ details: { detailsSvs }, caseState: { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
    data: detailsSvs.svsItems,
    currentSvsId: detailsSvs.id,
    itemsTabs: detailsSvs.svsItemsTabs,
    svsBlocked: selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
    instructionId: selectedCase.instructionId,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchSvs: (id: number) => dispatch(fetchSvs(id)),
    fetchSvssTotal: (instructionId: number) => dispatch(fetchSvsList(instructionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SvsList);
